import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Rtl2SsoService } from '@rtl2/sso';

export abstract class ApiAbstractService {
  static getHeader(): Object {
    return {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
  }

  constructor(
    protected http: HttpClient,
    protected sso?: Rtl2SsoService,
    protected apiServiceUrl = ''
  ) {}

  getTokenHeader(): Object {
    return {
      headers: this.getTokenHttpHeaders(),
    };
  }

  getTokenHttpHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('X-Auth-Token', this.sso.getToken());
  }

  delete<T>(
    endpoint: string,
    options?: { headers?: HttpHeaders; params?: HttpParams; observe?: 'body' }
  ) {
    return this.http.delete<T>(this.apiServiceUrl + endpoint, options);
  }

  get<T>(
    endpoint: string,
    options?: { headers?: HttpHeaders; params?: HttpParams; observe?: 'body' }
  ) {
    return this.http.get<T>(this.apiServiceUrl + endpoint, options);
  }

  options<T>(
    endpoint: string,
    options?: { headers?: HttpHeaders; params?: HttpParams; observe?: 'body' }
  ) {
    return this.http.options<T>(this.apiServiceUrl + endpoint, options);
  }

  patch<T>(
    endpoint: string,
    body: any,
    options?: { headers?: HttpHeaders; params?: HttpParams; observe?: 'body' }
  ) {
    return this.http.patch<T>(this.apiServiceUrl + endpoint, body, options);
  }

  post<T>(
    endpoint: string,
    body: any,
    options?: { headers?: HttpHeaders; params?: HttpParams; observe?: 'body' }
  ) {
    return this.http.post<T>(this.apiServiceUrl + endpoint, body, options);
  }

  put<T>(
    endpoint: string,
    body: any,
    options?: { headers?: HttpHeaders; params?: HttpParams; observe?: 'body' }
  ) {
    return this.http.put<T>(this.apiServiceUrl + endpoint, body, options);
  }
}
